// NDC passthrough — positions the quad directly in clip space,
// bypassing projection and model matrices.
export const TRANSITION_VERTEX = `
  varying vec2 vUv;

  void main() {
    vUv = uv;
    gl_Position = vec4(position.xy, 0.0, 1.0);
  }
`;
